export const ProjectBoardRouting = [
  {
    path: "/data-board",
    redirect: "/data-board/project-board/panel",
  },
  {
    path: "/data-board/project-board/panel",
    name: "data-board-project-board-panel",
    meta: { title: "项目数据看板" },
    component: () =>
      import(
        /* webpackCh`un`kName: "project-config-type" */ "@/views/data-board/project-board/panel/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/data-board/project-board/panel-state",
    name: "data-board-project-board-panel-state",
    meta: { title: "数据看板" },
    component: () =>
      import(
        /* webpackCh`un`kName: "project-config-type" */ "@/views/data-board/project-board/panel-state/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/data-board/project-board/panel-item/:id",
    name: "data-board-project-board-panel-item",
    meta: { title: "项目数据详情" },
    component: () =>
      import(
        /* webpackCh`un`kName: "project-config-type" */ "@/views/data-board/project-board/panel-item/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/data-board/project-board/panel-progress/:id",
    name: "data-board-project-board-panel-progress",
    meta: { title: "项目施工进度" },
    component: () =>
      import(
        /* webpackCh`un`kName: "project-config-type" */ "@/views/data-board/project-board/panel-progress/index.vue"
      ),
  },
];
